import { render, staticRenderFns } from "./i-audio-player.vue?vue&type=template&id=c0ea7070&scoped=true"
import script from "./i-audio-player.vue?vue&type=script&lang=js"
export * from "./i-audio-player.vue?vue&type=script&lang=js"
import style0 from "./i-audio-player.vue?vue&type=style&index=0&id=c0ea7070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea7070",
  null
  
)

export default component.exports